$(function() {
  // console.log('page'); 
});